module.exports = __webpack_public_path__ + "img/bevfam_luckydraw_btn.659ecb0c.png";